module.exports = __webpack_public_path__ + "img/34.3c3871f7.png";